export enum PassportTypeEnum {
  PASSPORT = 'PASSPORT', // Паспорт РФ
  FOREIGN_PASSPORT = 'FOREIGN_PASSPORT', // Иностранный паспорт
  FOREIGN_INTERNATIONAL_PASSPORT = 'FOREIGN_INTERNATIONAL_PASSPORT', // Загран. паспорт иностранного гражданина
  RF_INTERNATIONAL_PASSPORT = 'RF_INTERNATIONAL_PASSPORT', // Загран. паспорт гражданина РФ
  BIRTH_CERTIFICATE = 'BIRTH_CERTIFICATE', // Свидетельство о рождении
  RF_RESIDENCE_PERMIT = 'RF_RESIDENCE_PERMIT', // Вид на жительство РФ
}
